import React, { useEffect } from "react";
import { ActivityIndicator, Platform, ScrollView, View } from "react-native";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useRoute } from "@react-navigation/native";
import { fetchGetEventDetails } from "../actions/event";
import commonStyles, { COLOR2 } from "../styles/commonStyles";
import LiveEvent from "../components/LiveEvent";

const EventDetails = () => {
	const route = useRoute();
	const dispatch = useDispatch();
	const liveEventId = route.params?.id;

	const { isFetching, event } = useSelector(
		state => state.eventReducer,
		shallowEqual
	);

	useEffect(() => {
		if (liveEventId) {
			dispatch(fetchGetEventDetails(liveEventId));
		}
	}, [dispatch, liveEventId]);

	const { bgColor1, flex1, justifyContentCenter } = commonStyles;

	return (
		<View style={[flex1, bgColor1]}>
			{isFetching || !event ? (
				<ActivityIndicator
					style={[flex1, justifyContentCenter]}
					size="large"
					color={COLOR2}
				/>
			) : (
				<ScrollView
					{...(Platform.OS === "ios" && {
						scrollIndicatorInsets: { right: 0 },
						automaticallyAdjustsScrollIndicatorInsets: false
					})}
				>
					<LiveEvent item={event} isDetails={true} />
				</ScrollView>
			)}
		</View>
	);
};

export default EventDetails;
